import { proxy, snapshot, useSnapshot } from "@web-monorepo/hooks";
import { Timer, normalizeTimer } from ".";

const initialState: Timer = {
  seconds: undefined,
  startTime: null,
  endTime: null,
  remainingTime: null,
  increment: null,
  reset: false,
};

const store = proxy<Timer>({ ...initialState });

export const toolkitTimerActions = {
  setTime(time: Timer) {
    Object.assign(store, initialState, normalizeTimer(time));
  },
};

export function useToolkitTimerStore() {
  return useSnapshot(store);
}

export function getToolkitTimerState() {
  return snapshot(store);
}

export function resetToolkitTimerStore() {
  Object.assign(store, initialState);
}
